import {type ComponentPropsWithoutRef, type ReactNode, forwardRef} from "react"
import styles from "./Button.module.css"

interface ButtonProps extends ComponentPropsWithoutRef<"button"> {
    children?: ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({children, className, ...props}, ref) => {
        return (
            <button
                className={`${styles.button} ${className}`}
                ref={ref}
                {...props}
            >
                {children}
            </button>
        )
    }
)

Button.displayName = "Button"
